<template>
  <div>
    <form-wizard
      color="rgba(var(--vs-primary), 1)"
      errorColor="rgba(var(--vs-danger), 1)"
      :title="null"
      :subtitle="null"
      finishButtonText="Submit"
    >
      <!-- tab 1 content -->
      <tab-content
        title="Setup Payroll Cutoff"
        class="mb-5"
        :before-change="validateStep1"
      >
        <!-- :before-change="validateStep11"> -->
        <form data-vv-scope="step-1">
          <vx-card>
            <div class="vx-row">
              <vs-alert
                :active="isProcessed ? true : false"
                class="mt-5"
                icon-pack="feather"
                icon="icon-info"
                color="warning"
              >
                <span
                  >This has been processed, would you like to close the payroll
                  period {{ payOutDate | fulldate }}?.
                  <a href="#" class="hover:underline" @click="onCloseNow()"
                    >Close Period Now!</a
                  ></span
                >
              </vs-alert>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mt-5" style="font-size: 20px">
                <span class="text-sm shimmer"
                  ><b style="font-size: 20px">Payroll Number : </b></span
                >
                <b style="color: blue">{{ this.payrollNumber }}</b>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col sm:w-1/2 w-full mt-5" style="font-size: 20px">
                <span class="text-sm"
                  ><b style="font-size: 15px">Reference Number : </b></span
                >
                <b style="color: blue">{{ this.referenceNumber }}</b>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Payroll Type</span
                ><span style="color: red">*</span>
                <v-select
                  v-validate="'required'"
                  class="w-full"
                  name="payroll_type"
                  v-model="payrollType"
                  label="createPayrollTypeName"
                  :options="getAllCreatePayrollTypeLookup"
                  placeholder="Please Select"
                />
                <span class="text-danger">{{
                  errors.first("step-1.payroll_type")
                }}</span>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Payment Mode</span
                ><span style="color: red">*</span>
                <v-select
                  v-if="paymentMode"
                  v-validate="'required'"
                  class="w-full"
                  name="payment_mode"
                  v-model="paymentMode"
                  label="paymentModeName"
                  :options="getAllPaymentModeLookup"
                  placeholder="Please Select"
                />
                <span class="text-danger">{{
                  errors.first("step-1.payment_mode")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Period</span
                ><span style="color: red">*</span>
                <v-select
                  v-validate="'required'"
                  class="w-full"
                  name="period"
                  v-model="period"
                  label="periodName"
                  :options="getAllPeriodByPaymentMode"
                  placeholder="Please Select"
                  :disabled="this.paymentMode.paymentModeId ? false : true"
                />
                <span class="text-danger">{{
                  errors.first("step-1.period")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">PayOut Date</span
                ><span style="color: red">*</span>
                <datepicker
                  v-validate="'required'"
                  name="payOutDate"
                  v-model="payOutDate"
                  class="w-full"
                />
                <span class="text-danger">{{
                  errors.first("step-1.payOutDate")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Month Name</span
                ><span style="color: red">*</span>
                <v-select
                  v-validate="'required'"
                  class="w-full"
                  name="month"
                  v-model="month"
                  label="monthName"
                  :options="getAllMonthLookup"
                  placeholder="Please Select"
                />
                <span class="text-danger">{{
                  errors.first("step-1.month")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Cut-Off Date Start</span
                ><span style="color: red">*</span>
                <flat-pickr
                  v-validate="'required'"
                  name="cutoff_date_start"
                  v-model="fromCutOff"
                  class="w-full"
                />
                <span class="text-danger">{{
                  errors.first("step-1.cutoff_date_start")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Cut-Off Date End</span
                ><span style="color: red">*</span>
                <flat-pickr
                  v-validate="'required'"
                  name="cutoff_date_end"
                  v-model="toCutOff"
                  class="w-full"
                />
                <span class="text-danger">{{
                  errors.first("step-1.cutoff_date_end")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Calendar Year</span
                ><span style="color: red">*</span>
                <v-select
                  v-validate="'required'"
                  name="calendar_year"
                  label="year"
                  v-model="calendarYear"
                  :options="getYearsLookup"
                  class="w-full"
                />
                <span class="text-danger">{{
                  errors.first("step-1.calendar_year")
                }}</span>
              </div>
              <div class="vx-col md:w-1/2 w-full mt-5">
                <span class="text-sm">Remarks</span>
                <vs-input name="remarks" v-model="remarks" class="w-full" />
              </div>
            </div>
            <div class="vx-row">
              <div
                class="vx-col md:w-1/5 w-full mt-5"
                v-show="paymentMode.paymentModeId != 4"
              >
                <vs-checkbox
                  v-model="isMonthEnd"
                  :disabled="paymentMode.paymentModeId == 2 ? true : false"
                  >Month End?</vs-checkbox
                >
              </div>
              <div
                class="vx-col md:w-1/5 w-full mt-5"
                v-show="paymentMode.paymentModeId == 4"
              >
                <vs-checkbox v-model="isEndOfWeek">End Of Week?</vs-checkbox>
              </div>
              <div class="vx-col md:w-1/5 w-full mt-5">
                <vs-checkbox v-model="isYearEnd">Year-End?</vs-checkbox>
              </div>
              <div
                class="vx-col md:w-1/5 w-full mt-5"
                v-show="
                  payrollType.createPayrollTypeId === 1 ||
                  payrollType.createPayrollTypeId == 3 ||
                  payrollType.createPayrollTypeId == 4
                "
              >
                <vs-checkbox v-model="isAnnualized">Annualized?</vs-checkbox>
              </div>
              <div
                class="vx-col md:w-1/5 w-full mt-5"
                v-show="
                  payrollType.createPayrollTypeId == 3 ||
                  payrollType.createPayrollTypeId == 4
                "
              >
                <vs-checkbox v-model="isCutOffComplete"
                  >Is Complete CutOff?</vs-checkbox
                >
              </div>
              <div
                class="vx-col md:w-1/5 w-full mt-5"
                v-show="
                  payrollType.createPayrollTypeId == 5 ||
                  payrollType.createPayrollTypeId == 4 ||
                  payrollType.createPayrollTypeId == 3
                "
              >
                <vs-checkbox v-model="isAutoCompute13thMonth"
                  >Auto 13th Month?</vs-checkbox
                >
              </div>
            </div>
          </vx-card>
        </form>
        <div class="vx=row" v-if="getAllCreatePayroll">
          <vx-card>
            <vs-table
              stripe
              v-model="selected"
              max-items="4"
              pagination
              @selected="handleSelected"
              search
              :data="getAllCreatePayroll"
            >
              <template slot="thead">
                <vs-th sort-key="createdOn">Date Created</vs-th>
                <vs-th>Reference No</vs-th>
                <vs-th>Type</vs-th>
                <vs-th>Payment</vs-th>
                <vs-th>Period</vs-th>
                <vs-th>Cut-Off Start Date</vs-th>
                <vs-th>Cut-Off End Date</vs-th>
                <vs-th>PayOut Date</vs-th>
                <vs-th>Year</vs-th>
                <vs-th>Remarks</vs-th>
                <vs-th>Closed?</vs-th>
                <vs-th>Actions</vs-th>
              </template>
              <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].createdOn">
                    {{ data[indextr].createdOn | fulldate }}
                  </vs-td>
                  <vs-td :data="data[indextr].referenceNumber">
                    {{ data[indextr].referenceNumber }}
                  </vs-td>
                  <vs-td :data="data[indextr].createPayrollTypeId">
                    {{ data[indextr].createPayrollTypeId }}
                  </vs-td>
                  <vs-td :data="data[indextr].paymentModeId">
                    {{
                      paymentModeName(data[indextr].paymentModeId)
                        .paymentModeName
                    }}
                  </vs-td>
                  <vs-td :data="data[indextr].periodId">
                    {{ periodName(data[indextr].periodId).periodName }}
                  </vs-td>
                  <vs-td :data="data[indextr].cutOffStartDate">
                    {{ data[indextr].cutOffStartDate | fulldate }}
                  </vs-td>
                  <vs-td :data="data[indextr].cutOffEndDate">
                    {{ data[indextr].cutOffEndDate | fulldate }}
                  </vs-td>
                  <vs-td :data="data[indextr].payOutDate">
                    {{ data[indextr].payOutDate | fulldate }}
                  </vs-td>
                  <vs-td :data="data[indextr].calendarYear">
                    {{ data[indextr].calendarYear }}
                  </vs-td>
                  <vs-td :data="data[indextr].remarks">
                    {{ data[indextr].remarks }}
                  </vs-td>
                  <vs-td :data="data[indextr].isClosed">
                    <vs-chip :color="chipColor(data[indextr].isClosed ? 3 : 1)">
                      <span>{{
                        data[indextr].isClosed ? "Closed" : "Open"
                      }}</span>
                    </vs-chip>
                  </vs-td>
                  <vs-td>
                    <div
                      :style="{ direction: $vs.rtl ? 'rtl' : 'ltr' }"
                      v-show="!data[indextr].isClosed"
                    >
                      <feather-icon
                        icon="Edit3Icon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                        @click="editRecord(data[indextr].createdScheduleId)"
                      />
                      <feather-icon
                        icon="Trash2Icon"
                        svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                        @click="
                          confirmDeleteRecord(data[indextr].createdScheduleId)
                        "
                      />
                    </div>
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </vx-card>
        </div>
      </tab-content>
      <!-- tab 2 content -->
      <tab-content
        title="Select Employees"
        class="mb-5"
        :before-change="validateStep2"
      >
        <select-employees
          v-if="payrollType != null"
          :createPayroll="getCreatePayrollData"
          :isValidate2="isValidate2"
        />
      </tab-content>
      <tab-content
        title="Process Time Logs"
        class="mb-5"
        :before-change="validateStep3"
      >
        <form data-vv-scope="step-3">
          <process-time-logs
            v-if="payrollType != null"
            :createPayroll="getCreatePayrollData"
          />
        </form>
      </tab-content>
      <tab-content
        title="Checking & Validation"
        class="mb-5"
        :before-change="validateStep4"
      >
        <!-- <form data-vv-scope="step-4"> -->
        <checking-validation
          v-if="payrollType != null"
          :createPayroll="getCreatePayrollData"
          :isValidate3="isValidate3"
        />
        <!-- </form> -->
      </tab-content>
      <tab-content
        title="Calculate Payroll"
        class="mb-5"
        :before-change="validateStep5"
      >
        <form data-vv-scope="step-5">
          <calculate-payroll
            v-if="payrollType != null"
            :createPayroll="getCreatePayrollData"
            :isValidate5="isValidate5"
          />
        </form>
      </tab-content>
      <tab-content
        title="Generate Reports"
        class="mb-5"
        :before-change="validateStep6"
      >
        <form data-vv-scope="step-6">
          <generate-reports
            v-if="payrollType != null"
            :createPayroll="getCreatePayrollData"
            :isValidate6="isValidate6"
          />
        </form>
      </tab-content>
      <tab-content
        title="Close Period"
        class="mb-5"
        :before-change="validateStep7"
      >
        <form data-vv-scope="step-7">
          <close-payroll-period
            v-if="payrollType != null"
            :createPayroll="getCreatePayrollData"
            :isValidate7="isValidate7"
          />
        </form>
      </tab-content>
    </form-wizard>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";

import Datepicker from "vuejs-datepicker";
import { en, he } from "vuejs-datepicker/src/locale";

import moment from "moment";
import vSelect from "vue-select";

import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

// For custom error message
import { Validator } from "vee-validate";

const dict = {
  custom: {
    payroll_type: {
      required: "Payroll Type is required",
    },
    payment_mode: {
      required: "Payment Mode is required",
    },
    period: {
      required: "Period is required",
    },
    payOutDate: {
      required: "PayOut Date is required",
    },
    month: {
      required: "Month is required",
    },
    cutoff_date_start: {
      required: "Cut-Off Date Start is required",
    },
    cutoff_date_end: {
      required: "Cut-Off Date End is required",
    },
    calendar_year: {
      required: "Year is required",
    },
  },
};

// register custom messages
Validator.localize("en", dict);
import SelectEmployees from "./SelectEmployees.vue";
import ProcessTimeLogs from "./ProcessTimeLogs.vue";
import CheckingValidation from "./CheckingValidation.vue";
import CalculatePayroll from "./CalculatePayroll.vue";
import GenerateReports from "./GenerateReports.vue";
import ClosePayrollPeriod from "./ClosePayrollPeriod.vue";

export default {
  data() {
    return {
      selected: [],
      payrollNumber: 0,
      referenceNumber: "",
      payrollType: {
        createPayrollTypeId: 2,
      },
      paymentMode: [],
      period: null,
      fromCutOff: null,
      toCutOff: null,
      payOutDate: null,
      month: [],
      isMonthEnd: false,
      isEndOfWeek: false,
      isClosed: false,
      calendarYear: null,
      remarks: "",
      isAnnualized: false,
      isYearEnd: false,
      isCutOffComplete: false,
      isAutoCompute13thMonth: false,

      tableData: [],
      isValidate2: false,
      isValidate3: false,
      isValidate5: false,
      isValidate6: false,
      isValidate7: false,

      isProcessed: false,
    };
  },
  watch: {
    payrollType() {
      this.isValidate2 = false;
      this.onCreatePayrollData();
    },
    payOutDate() {
      this.getMonthData;
    },
    period() {
      if (this.period != null)
        this.isMonthEnd =
          this.period.periodId == 4 || this.period.periodId == 2 ? true : false;
    },
  },
  created() {
    this.$vs.loading();
    const payload = {
      pageNumber: 1,
      pageSize: -1,
      sortBy: "CreatedOn",
      sortOrder: "Desc",
    };
    this.$store.dispatch("tenants/getAllTenants", payload).catch((err) => {
      console.error(err);
    });

    const data = {
      pageNumber: 1,
      pageSize: -1,
    };

    this.$store.dispatch("lookup/getAllPaymentModeLookup").catch((err) => {
      console.log(err);
    });
    this.$store.dispatch("lookup/getAllPeriodLookup").catch((err) => {
      console.log(err);
    });
    this.$store
      .dispatch("lookup/getAllCreatePayrollTypeLookup")
      .catch((err) => {
        console.log(err);
      });
    this.$store
      .dispatch("tenants/getAllTenantsSchedule", {
        tenantsId: this.$store.state.AppActiveUser.tenantsId,
      })
      .catch((err) => {
        console.log(err);
      });
    this.$store
      .dispatch("tenants/getAllSettings", {
        tenantsId: this.$store.state.AppActiveUser.tenantsId,
      })
      .catch((err) => {
        console.log(err);
      });
    this.$store.dispatch("payroll/getAllCreatePayroll").catch((err) => {
      console.log(err);
    });
    this.$store
      .dispatch("hrms/getAllEmployee", data)
      .then(() => {
        this.$vs.loading.close();
      })
      .catch((err) => {
        this.$vs.loading.close();
        console.log(err);
      });
  },
  computed: {
    getAllCreatePayroll() {
      return this.$store.state.payroll.getAllCreatePayroll;
    },
    getAllCreatePayrollTypeLookup() {
      // console.log(this.$store.getters['lookup/paymentModeActive'](true))
      // return this.$store.getters['lookup/paymentModeActive'](true)
      return this.$store.state.lookup.getAllCreatePayrollTypeLookup;
    },
    getAllPaymentModeLookup() {
      // return this.$store.state.lookup.getAllPaymentModeLookup
      return this.$store.getters["lookup/paymentModeActive"](true);
    },
    getAllPeriodByPaymentMode() {
      this.period = null;
      return this.$store.getters["lookup/periodLookupForCreatePayroll"](
        this.paymentMode.paymentModeId
      );
    },
    getAllMonthLookup() {
      return this.$store.state.lookup.monthName;
    },
    getYearsLookup() {
      const year = new Date().getFullYear();
      return Array.from(
        { length: year - 2020 },
        (value, index) => 2021 + index
      );
    },
    getMonthData() {
      var d = new Date(this.payOutDate);
      this.month = this.getMonthName(d.getMonth() + 1);
    },
    getMonthName() {
      return (id) => this.$store.getters["lookup/monthLookup"](id);
    },
    getCreatePayrollData() {
      return this.$store.getters["payroll/getCreatePayrollByPayrollType"](
        this.payrollType.createPayrollTypeId
      );
    },
    paymentModeName() {
      return (id) => this.$store.getters["lookup/paymentModeLookup"](id);
    },
    periodName() {
      return (id) => this.$store.getters["lookup/periodLookup"](id);
    },
    chipColor() {
      return (value) => {
        if (value > 0) {
          if (value == 1) return "success";
          else if (value == 2) return "warning";
          else return "danger";
        } else {
          if (!value) return "success";
          else return "danger";
        }
      };
    },
  },
  methods: {
    validateStep1() {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-1").then((result) => {
          if (result) {
            resolve(true);

            if (this.payrollNumber == 0) {
              this.$vs.loading();

              const data = {
                createPayrollTypeId: this.payrollType.createPayrollTypeId,
                paymentModeId: this.paymentMode.paymentModeId,
                referenceNumber:
                  this.payrollType.createPayrollTypeName.charAt(0) +
                  this.payrollType.createPayrollTypeId +
                  this.paymentMode.paymentModeId +
                  moment(this.payOutDate).format("YYYYMMDDhhmm"),
                periodId: this.period.periodId,
                cutOffStartDate: this.fromCutOff,
                cutOffEndDate: this.toCutOff,
                payOutDate: this.payOutDate,
                monthName: this.month.value,
                calendarYear: this.calendarYear,
                isMonthEnd: this.isMonthEnd,
                isEndOfWeek: this.isEndOfWeek,
                isClosed: false,
                remarks: this.remarks,
                isAnnualized: this.isAnnualized,
                isYearEnd: this.isYearEnd,
                currentUserId: this.$store.state.AppActiveUser.uid,
                isCutOffComplete: this.isCutOffComplete,
                isAutoCompute13thMonth: this.isAutoCompute13thMonth,
              };
              //console.log(data)
              this.$store
                .dispatch("payroll/addCreatePayroll", data)
                .then((res) => {
                  this.$vs.loading.close();
                  this.isValidate2 = true;
                  this.payrollNumber = res.data.data.createPayrollId;
                  this.referenceNumber = res.data.data.referenceNumber;
                })
                .catch((err) => {
                  this.$vs.loading.close();
                  console.log(err);
                });
            } else {
              this.$vs.loading();
              const data2 = {
                createPayrollId: this.payrollNumber,
                createPayrollTypeId: this.payrollType.createPayrollTypeId,
                paymentModeId: this.paymentMode.paymentModeId,
                referenceNumber:
                  this.payrollType.createPayrollTypeName.charAt(0) +
                  this.payrollType.createPayrollTypeId +
                  this.paymentMode.paymentModeId +
                  moment(this.payOutDate).format("YYYYMMDDhhmm"),
                periodId: this.period.periodId,
                cutOffStartDate: this.fromCutOff,
                cutOffEndDate: this.toCutOff,
                payOutDate: this.payOutDate,
                monthName: this.month.value,
                calendarYear: this.calendarYear,
                isMonthEnd: this.isMonthEnd,
                isEndOfWeek: this.isEndOfWeek,
                isClosed: this.isClosed,
                remarks: this.remarks,
                isAnnualized: this.isAnnualized,
                isYearEnd: this.isYearEnd,
                currentUserId: this.$store.state.AppActiveUser.uid,
                isCutOffComplete: this.isCutOffComplete,
                isAutoCompute13thMonth: this.isAutoCompute13thMonth,
              };
              //console.log('UPDATE')
              //console.log(data2)
              this.$store
                .dispatch("payroll/updateCreatePayroll", data2)
                .then((res) => {
                  this.$vs.loading.close();
                  this.isValidate2 = true;
                })
                .catch((err) => {
                  this.$vs.loading.close();
                  console.log(err);
                });
            }
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep2() {
      //Select Employees
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-2").then((result) => {
          if (result) {
            resolve(true);
            this.isValidate3 = false;
          }
        });
      });
    },
    validateStep3() {
      //Generate Logs / Upload Logs
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-3").then((result) => {
          if (result) {
            resolve(true);
            this.isValidate3 = true;
          } else {
            reject("correct all values");
          }
        });
      });
    },
    validateStep4() {
      //CHECK & VALIDATION
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-4").then((result) => {
          if (result) {
            resolve(true);
            this.isValidate5 = false;
            this.$confirm(
              "Would you like to calculate the payroll?",
              "Calculate Payroll"
            ).then(() => {
              this.isValidate5 = true;
              this.isValidate6 = false;
            });
          }
        });
      });
    },
    validateStep5() {
      //CALCULATE PAYROLL
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-5").then((result) => {
          if (result) {
            resolve(true);
            this.isValidate6 = true;
            this.isValidate7 = false;
          }
        });
      });
    },
    validateStep6() {
      //GENERATE REPORTS
      return new Promise((resolve, reject) => {
        this.$validator.validateAll("step-6").then((result) => {
          if (result) {
            resolve(true);
            this.isValidate7 = true;
          }
        });
      });
    },
    validateStep7() {
      //CLOSE PERIOD
      return new Promise((resolve, reject) => {
        this.$validator
          .validateAll("step-7")
          .then((result) => {
            if (result) {
              resolve(true);
              this.isValidate7 = false;
            }
          })
          .catch((error) => {
            reject(error);
            this.isValidate7 = false;
          });
      });
    },
    onCreatePayrollData() {
      const e = this.$store.getters["payroll/getCreatePayrollByPayrollType"](
        this.payrollType.createPayrollTypeId
      );
      if (e != null) {
        (this.payrollNumber = e.createPayrollId),
          (this.paymentMode = this.paymentModeName(e.paymentModeId)),
          this.getAllPeriodByPaymentMode;
        (this.referenceNumber = e.referenceNumber),
          (this.period = this.periodName(e.periodId)),
          (this.fromCutOff = e.cutOffStartDate),
          (this.toCutOff = e.cutOffEndDate),
          (this.payOutDate = e.payOutDate),
          (this.month = this.getMonthName(e.monthName)),
          (this.calendarYear = e.calendarYear),
          (this.isMonthEnd = e.isMonthEnd),
          (this.isEndOfWeek = e.isEndOfWeek),
          (this.isClosed = e.isClosed),
          (this.remarks = e.remarks),
          (this.isAnnualized = e.isAnnualized),
          (this.isYearEnd = e.isYearEnd),
          (this.isCutOffComplete = e.isCutOffComplete),
          (this.isAutoCompute13thMonth = e.isAutoCompute13thMonth);
      } else {
        this.payrollNumber = 0;
        (this.paymentMode = []),
          (this.referenceNumber = ""),
          (this.period = null),
          (this.fromCutOff = null),
          (this.toCutOff = null),
          (this.payOutDate = null),
          (this.month = []),
          (this.calendarYear = null),
          (this.isMonthEnd = false),
          (this.isEndOfWeek = false),
          (this.isClosed = false),
          (this.remarks = ""),
          (this.isAnnualized = e.createPayrollId == 4 ? true : false),
          (this.isYearEnd = false);
        this.isCutOffComplete = false;
        this.isAutoCompute13thMonth = false;
      }
      this.$vs.loading();
      this.$http
        .get(`/api/payroll/employeenetpayByPayrollId/${this.payrollNumber}`)
        .then((response) => {
          if (response.data.data.length != 0) {
            this.$store
              .dispatch("payroll/getAllLogHoursByPayrollId", this.payrollNumber)
              .then(() => {
                this.$vs.loading.close();
              })
              .catch((err) => {
                this.$vs.loading.close();
                console.log(err);
              });
            this.isProcessed = true;
          }
          this.$vs.loading.close();
        })
        .catch((err) => {
          this.$vs.loading.close();
          console.log(err);
        });
    },
    handleSelected() {},
    onCloseNow() {
      this.isValidate7 = true;
      this.validateStep7();
    },
  },

  components: {
    FormWizard,
    TabContent,
    "v-select": vSelect,
    Datepicker,
    flatPickr,
    SelectEmployees,
    ProcessTimeLogs,
    CheckingValidation,
    CalculatePayroll,
    GenerateReports,
    ClosePayrollPeriod,
  },
};
</script>
,

<style lang="scss">
@import "@/assets/scss/vuexy/apps/email.scss";
@import "@/assets/scss/vuexy/apps/simple-calendar.scss";
</style>
